import PropTypes from 'prop-types'

import { Box } from '@mui/material'

import { ReactComponent as Success } from '../../../../assets/icons/success.svg'
import { ReactComponent as WarningFill } from '../../../../assets/icons/warning-fill.svg'
import { ReactComponent as Resolved } from '../../../../assets/icons/step-resolved.svg'

import styles from '../styles'

const TimelineMobile = ({ shipmentStatus, shipmentInfo, state }) => {
  const failedDelivery = shipmentStatus === 'primary'
  const isSolved = (state?.length ? state[0] : null)?.severity === 'orange'
  return (
    <Box
      sx={{
        ...styles.timeline,
        ...(isSolved
          ? styles.timelineSolved
          : failedDelivery
          ? styles.timelineError
          : {}),
      }}
    >
      <Box sx={{ ...styles.point, ...styles.mainPoint }}>
        <Success sx={styles.mainPointIcon} />
      </Box>
      <Box sx={{ ...styles.point, ...styles.secondaryPoint }} />
      <Box sx={{ ...styles.point, ...styles.secondaryPoint }} />
      <Box sx={{ ...styles.point, ...styles.secondaryPoint }} />
      <Box sx={{ ...styles.point, ...styles.secondaryPoint }} />
      <Box
        sx={{
          ...styles.point,
          ...styles.mainPoint,
          ...(isSolved
            ? styles.mainPointSolved
            : failedDelivery
            ? styles.mainPointError
            : {}),
        }}
      >
        {isSolved ? (
          <Resolved />
        ) : failedDelivery ? (
          <WarningFill />
        ) : (
          <Success />
        )}
      </Box>
    </Box>
  )
}

TimelineMobile.propTypes = {
  shipmentStatus: PropTypes.string,
}

export default TimelineMobile
